/** @format */

import React from 'react';

export const MegaMenuLabels = ({onMouseLeave, onMouseOver, isMobile, display = 'none'}) => {
    // menu links

    const labelProductTypeLinks = {
        base: '/labels/label-types',
        supplement: '/labels/label-types/supplement-vitamin-bottle-labels',
        cbd: '/labels/label-types/cbd-labels',
        cosmetic: '/labels/label-types/bath-body-and-cosmetic-labels',
        candle: '/labels/label-types/custom-candle-labels',
        food: '/labels/label-types/custom-food-labels',
        coffee: '/labels/label-types/custom-coffee-labels',
        lip_balm: '/labels/label-types/lip-balm-labels',
        vape: '/labels/label-types/vape-and-e-juice-labels',
        soap: '/labels/label-types/custom-soap-labels',
        wine: '/labels/label-types/custom-wine-labels',
        sanitizer: '/labels/label-types/hand-sanitizer-labels',
        cannabis: '/labels/label-types/cannabis-labels',
        honey: '/labels/label-types/custom-honey-labels',
        water_proof: '/labels/label-types/waterproof-labels',
        clear_labels: '/labels/label-types/custom-clear-labels',
        bottle_labels: '/labels/label-types/custom-bottle-labels',
        bag_labels: '/labels/label-types/bag-labels',
        metallic_labels: '/labels/label-types/custom-metallic-labels',
        eco_friendly: '/labels/label-types/eco-friendly-labels',
        spray_bottle: '/labels/label-types/custom-spray-bottle-labels',
        dropper_bottle: '/labels/label-types/dropper-bottle-labels',
        jar_labels: '/labels/label-types/custom-jar-labels'
    };

    const labelMaterialAndLaminatesLinks = {
        materials_base: '/labels/label-materials',
        white_plastic: '/labels/label-materials/white-plastic-labels',
        metallic_plastic: '/labels/label-materials/metallic-plastic-labels',
        white_paper: '/labels/label-materials/white-paper-labels',
        white_vinyl: '/labels/label-materials/white-vinyl-labels',
        avon_classic_crest: '/labels/label-materials/avon-crest-paper-labels',
        ultra_clear_plastic: '/labels/label-materials/ultra-clear-plastic-labels',
        clear_plastic: '/labels/label-materials/clear-plastic-labels',
        estate_four_paper: '/labels/label-materials/estate-4-paper-labels',
        terraskin: '/labels/label-materials/terraskin-labels',
        black_vellum: '/labels/label-materials/black-vellum-labels',
        removable_plastic: '/labels/label-materials/removable-labels',
        laminates_base: '/labels/label-laminates',
        gloss: '/labels/label-laminates/gloss-laminate',
        soft_touch_matte: '/labels/label-laminates/soft-touch-matte-laminate',
        uv_resistant_gloss: '/labels/label-laminates/uv-resistant-gloss-laminate',
        matte: '/labels/label-laminates/matte-laminate',
        linen: '/labels/label-laminates/linen-laminate',
        leather: '/labels/label-laminates/leather-laminate',
        holographic: '/labels/label-laminates/rainbow-laminate'
    };

    const orderLabels = '/orders/custom-labels';
    return (
        <div
            className="header-23cr_megamenus-toggler megamenus-toggler--labels"
            onMouseLeave={!isMobile ? onMouseLeave : null}
            onMouseOver={!isMobile ? onMouseOver : null}
            style={{display}}>
            <nav
                aria-labelledby="sub-nav"
                className="header-23cr_megamenu-container megamenu-container-labels">
                <div className="header-23cr_megamenu">
                    <div className="megamenu-23cr_links">
                        {/*  Image Lnk*/}
                        <div className="links-23cr_link link-image">
                            <div className="link-23cr_title">
                                <h3>
                                    <a href={labelProductTypeLinks['base']}>Custom Labels</a>
                                </h3>
                                <span className="title-23cr_carat">
                                    <svg
                                        width="8"
                                        height="5"
                                        viewBox="0 0 8 5"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0.166687L4 4.16669L8 0.166687H0Z" />
                                    </svg>
                                </span>
                            </div>
                            <div
                                className="link-image-23cr_image"
                                style={{
                                    backgroundImage: `linear-gradient(0deg, rgba(20, 20, 20, 0.55), rgba(20, 20, 20, 0.55)), url('/images/header_footer/products_labels.webp')`
                                }}>
                                <a href={orderLabels}>
                                    <h6>Get An Instant Quote</h6>
                                </a>
                            </div>
                        </div>

                        {/*  Product Types */}
                        <div className="links-23cr_link">
                            <div className="link-23cr_title">
                                <h3>
                                    <a href={labelProductTypeLinks['base']}>Product Types</a>
                                </h3>
                                <span className="title-23cr_carat">
                                    <svg
                                        width="8"
                                        height="5"
                                        viewBox="0 0 8 5"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0.166687L4 4.16669L8 0.166687H0Z" />
                                    </svg>
                                </span>
                            </div>
                            <div className="link-23cr_links-list">
                                {/* first column*/}
                                <ul className="links-list-23cr_column column-first">
                                    <li>
                                        <a
                                            href={`${labelProductTypeLinks['supplement']}`}
                                            className="d-block">
                                            Supplement Labels
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={`${labelProductTypeLinks['cbd']}`}
                                            className="d-block">
                                            CBD Labels
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={`${labelProductTypeLinks['cosmetic']}`}
                                            className="d-block">
                                            Cosmetic Labels
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={`${labelProductTypeLinks['candle']}`}
                                            className="d-block">
                                            Candle Labels
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={`${labelProductTypeLinks['food']}`}
                                            className="d-block">
                                            Food Labels
                                        </a>
                                    </li>

                                    {/*column section*/}
                                    <li>
                                        <h6 className="column_section-title">
                                            Specialty Label Types
                                        </h6>
                                    </li>
                                    <li>
                                        <a
                                            href={labelProductTypeLinks['water_proof']}
                                            className="d-block">
                                            Waterproof Labels
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={labelProductTypeLinks['clear_labels']}
                                            className="d-block">
                                            Clear Labels
                                        </a>
                                    </li>
                                    {/*column section*/}
                                    <li>
                                        <h6 className="column_section-title">Packaging Types</h6>
                                    </li>
                                    <li>
                                        <a
                                            href={labelProductTypeLinks['bottle_labels']}
                                            className="d-block">
                                            Bottle Labels
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={labelProductTypeLinks['bag_labels']}
                                            className="d-block">
                                            Bag Labels
                                        </a>
                                    </li>
                                </ul>
                                <ul className="links-list-23cr_column column-second">
                                    <li>
                                        <a
                                            href={`${labelProductTypeLinks['coffee']}`}
                                            className="d-block">
                                            Coffee Labels
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={`${labelProductTypeLinks['lip_balm']}`}
                                            className="d-block">
                                            Lip Balm Labels
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={`${labelProductTypeLinks['vape']}`}
                                            className="d-block">
                                            Vape Labels
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={`${labelProductTypeLinks['soap']}`}
                                            className="d-block">
                                            Soap Labels
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={`${labelProductTypeLinks['wine']}`}
                                            className="d-block">
                                            Wine Labels
                                        </a>
                                    </li>

                                    <li className="column_no-content">
                                        <h6>_</h6>
                                    </li>
                                    <li>
                                        <a
                                            href={labelProductTypeLinks['metallic_labels']}
                                            className="d-block">
                                            Metallic Labels
                                        </a>
                                    </li>
                                    <li className="column_no-content">_</li>
                                    <li className="column_no-content">
                                        <h6>_</h6>
                                    </li>
                                    <li>
                                        <a
                                            href={labelProductTypeLinks['spray_bottle']}
                                            className="d-block">
                                            Spray Bottle Labels
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={labelProductTypeLinks['dropper_bottle']}
                                            className="d-block">
                                            Dropper Bottle Labels
                                        </a>
                                    </li>
                                </ul>
                                <ul className="links-list-23cr_column colun-third">
                                    <li>
                                        <a
                                            href={`${labelProductTypeLinks['sanitizer']}`}
                                            className="d-block">
                                            Sanitizer Labels
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={`${labelProductTypeLinks['cannabis']}`}
                                            className="d-block">
                                            Cannabis Labels
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={`${labelProductTypeLinks['honey']}`}
                                            className="d-block">
                                            Honey Labels
                                        </a>
                                    </li>
                                    <li className="column_no-content">_</li>
                                    <li className="column_no-content">_</li>
                                    <li className="column_no-content">
                                        <h6>_</h6>
                                    </li>
                                    <li>
                                        <a
                                            href={`${labelProductTypeLinks['eco_friendly']}`}
                                            className="d-block">
                                            Eco Friendly Labels
                                        </a>
                                    </li>
                                    <li className="column_no-content">_</li>
                                    <li className="column_no-content">
                                        <h6>_</h6>
                                    </li>
                                    <li>
                                        <a
                                            href={`${labelProductTypeLinks['jar_labels']}`}
                                            className="d-block">
                                            Jar Labels
                                        </a>
                                    </li>

                                    <li className="column_no-content">_</li>
                                </ul>
                            </div>
                        </div>

                        {/*  Materials */}
                        <div className="links-23cr_link links-23cr_link-labels-materials-and-laminates column-materials-232nfs">
                            <div className="link-23cr_title">
                                <h3>
                                    <a
                                        className="column_heading-link"
                                        href={labelMaterialAndLaminatesLinks['materials_base']}>
                                        Materials
                                    </a>
                                </h3>
                                <span className="title-23cr_carat">
                                    <svg
                                        width="8"
                                        height="5"
                                        viewBox="0 0 8 5"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0.166687L4 4.16669L8 0.166687H0Z"></path>
                                    </svg>
                                </span>
                            </div>
                            <div className="link-23cr_links-list">
                                <ul className="links-list-23cr_column">
                                    <li>
                                        <a
                                            href={labelMaterialAndLaminatesLinks['white_plastic']}
                                            className="d-block">
                                            White Plastic
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={
                                                labelMaterialAndLaminatesLinks['metallic_plastic']
                                            }
                                            className="d-block">
                                            Metallic Plastic
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={labelMaterialAndLaminatesLinks['white_paper']}
                                            className="d-block">
                                            White Paper
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={labelMaterialAndLaminatesLinks['white_vinyl']}
                                            className="d-block">
                                            White Vinyl
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={
                                                labelMaterialAndLaminatesLinks['avon_classic_crest']
                                            }
                                            className="d-block">
                                            Avon Classic Crest
                                        </a>
                                    </li>
                                    {/*nested column materials */}
                                    <li className="column_nested-materials">
                                        <div className="links-23cr_link links-23cr_link-labels-materials-and-laminates">
                                            <div className="link-23cr_title">
                                                <h3>
                                                    <a
                                                        className="column_heading-link"
                                                        href={
                                                            labelMaterialAndLaminatesLinks[
                                                                'laminates_base'
                                                            ]
                                                        }>
                                                        Laminates
                                                    </a>
                                                </h3>
                                                <span className="title-23cr_carat">
                                                    <svg
                                                        width="8"
                                                        height="5"
                                                        viewBox="0 0 8 5"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 0.166687L4 4.16669L8 0.166687H0Z"></path>
                                                    </svg>
                                                </span>
                                            </div>
                                            <div className="link-23cr_links-list">
                                                <ul className="links-list-23cr_column">
                                                    <li>
                                                        <a
                                                            href={
                                                                labelMaterialAndLaminatesLinks[
                                                                    'gloss'
                                                                ]
                                                            }
                                                            className="d-block">
                                                            Gloss
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            href={
                                                                labelMaterialAndLaminatesLinks[
                                                                    'soft_touch_matte'
                                                                ]
                                                            }
                                                            className="d-block">
                                                            Soft Touch Matte
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            href={
                                                                labelMaterialAndLaminatesLinks[
                                                                    'uv_resistant_gloss'
                                                                ]
                                                            }
                                                            className="d-block">
                                                            UV Resistant Gloss
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            href={
                                                                labelMaterialAndLaminatesLinks[
                                                                    'matte'
                                                                ]
                                                            }
                                                            className="d-block">
                                                            Matte
                                                        </a>
                                                    </li>
                                                </ul>
                                                <ul className="links-list-23cr_column">
                                                    <li>
                                                        <a
                                                            href={
                                                                labelMaterialAndLaminatesLinks[
                                                                    'linen'
                                                                ]
                                                            }
                                                            className="d-block">
                                                            Linen
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            href={
                                                                labelMaterialAndLaminatesLinks[
                                                                    'leather'
                                                                ]
                                                            }
                                                            className="d-block">
                                                            Leather
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <ul className="links-list-23cr_column column_laminates-last-column">
                                    <li>
                                        <a
                                            href={
                                                labelMaterialAndLaminatesLinks[
                                                    'ultra_clear_plastic'
                                                ]
                                            }
                                            className="d-block">
                                            Ultra-Clear Plastic
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={labelMaterialAndLaminatesLinks['clear_plastic']}
                                            className="d-block">
                                            Clear Plastic
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={
                                                labelMaterialAndLaminatesLinks['estate_four_paper']
                                            }
                                            className="d-block">
                                            Estate 4 Paper
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={labelMaterialAndLaminatesLinks['terraskin']}
                                            className="d-block">
                                            Terra Skin
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={labelMaterialAndLaminatesLinks['rainbow']}
                                            className="d-block">
                                            Rainbow Holographic
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* Laminates*/}
                        <div className="links-23cr_link links-23cr_link-labels-materials-and-laminates links-23cr_laminates">
                            <div className="link-23cr_title">
                                <h3>
                                    <a
                                        className="column_heading-link"
                                        href={labelMaterialAndLaminatesLinks['laminates_base']}>
                                        Laminates
                                    </a>
                                </h3>
                                <span className="title-23cr_carat">
                                    <svg
                                        width="8"
                                        height="5"
                                        viewBox="0 0 8 5"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0.166687L4 4.16669L8 0.166687H0Z"></path>
                                    </svg>
                                </span>
                            </div>
                            <div className="link-23cr_links-list">
                                <ul className="links-list-23cr_column">
                                    <li>
                                        <a
                                            href={labelMaterialAndLaminatesLinks['gloss']}
                                            className="d-block">
                                            Gloss
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={
                                                labelMaterialAndLaminatesLinks['soft_touch_matte']
                                            }
                                            className="d-block">
                                            Soft Touch Matte
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={
                                                labelMaterialAndLaminatesLinks['uv_resistant_gloss']
                                            }
                                            className="d-block">
                                            UV Resistant Gloss
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={labelMaterialAndLaminatesLinks['matte']}
                                            className="d-block">
                                            Matte
                                        </a>
                                    </li>
                                </ul>
                                <ul className="links-list-23cr_column">
                                    <li>
                                        <a
                                            href={labelMaterialAndLaminatesLinks['linen']}
                                            className="d-block">
                                            Linen
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={labelMaterialAndLaminatesLinks['leather']}
                                            className="d-block">
                                            Leather
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    );
};
